module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_5-071fdb6efa33b914f62f9ae2fc7bd143.png";